/**
 * Lot Navigation Action Enum
 *
 * Discriminates the navigation decision selectLotRoutingOutcome (redux/selectors.js) returns for
 * a lot click, so lotSelectedEpic can translate it into the matching Redux action without
 * comparing against magic strings.
 * Uses singleton pattern for instance management.
 *
 * @module nativeInteractiveSiteMap/enums/lotNavigationAction
 */

export default class LotNavigationAction {
  static instances = {};

  /** Navigate to the resolved view/context — dispatch navigateTo({ view, context }). */
  static get NavigateTo() {
    return this.getInstance('navigateTo');
  }

  /** Unwind to whatever view was active before — dispatch navigateBack(). */
  static get NavigateBack() {
    return this.getInstance('navigateBack');
  }

  /** @private */
  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new LotNavigationAction(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return this.name;
  }
}
